import { render, staticRenderFns } from "./CuentaPagos.vue?vue&type=template&id=5b355832&scoped=true"
import script from "./CuentaPagos.vue?vue&type=script&lang=js"
export * from "./CuentaPagos.vue?vue&type=script&lang=js"
import style0 from "./CuentaPagos.vue?vue&type=style&index=0&id=5b355832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b355832",
  null
  
)

export default component.exports